import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { auth } from "../../firebase/client";
import { initNewUser } from "../../lib/init-user-profile";

const googleProvider = new GoogleAuthProvider();

const FIREBASE_ERRORS: Record<string, string> = {
	"auth/email-already-in-use": "An account with that email already exists.",
	"auth/invalid-email": "Please enter a valid email address.",
	"auth/weak-password": "Password must be at least 6 characters.",
};

const Register = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const next = searchParams.get("next") ?? "/";
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirm, setConfirm] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	const onSuccess = () => navigate(next);

	const handleGoogle = async () => {
		setError(null);
		setLoading(true);
		try {
			const result = await signInWithPopup(auth, googleProvider);
			initNewUser(result.user);
			onSuccess();
		} catch {
			setError("Google sign-in failed — please try again.");
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);
		if (password !== confirm) {
			setError("Passwords don't match.");
			return;
		}
		setLoading(true);
		try {
			const result = await createUserWithEmailAndPassword(auth, email, password);
			initNewUser(result.user);
			onSuccess();
		} catch (err: unknown) {
			const code = (err as { code?: string }).code ?? "";
			setError(FIREBASE_ERRORS[code] ?? "Registration failed — please try again.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<h2>Create account</h2>
			<button type="button" onClick={handleGoogle} disabled={loading}>
				Continue with Google
			</button>
			<hr />
			<form onSubmit={handleSubmit}>
				<div>
					<label>
						Email
						<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
					</label>
				</div>
				<div>
					<label>
						Password
						<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
					</label>
				</div>
				<div>
					<label>
						Confirm password
						<input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
					</label>
				</div>
				{error && <p>{error}</p>}
				<button type="submit" disabled={loading}>{loading ? "Creating account…" : "Create account"}</button>
			</form>
			<p>Already have an account? <Link to="/login">Sign in</Link></p>
		</div>
	);
};

export default Register;
